import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

class Radio extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: props.checked,
    };

    this.handleChange = this.handleChange.bind(this);
    this.setRef = this.setRef.bind(this);
  }

  setRef(el) {
    this.el = el;
  }

  handleChange(event) {
    event.stopPropagation();
    const { target } = event;
    const { checked: isChecked, value } = target;

    this.setState(
      {
        isChecked,
      },
      () => {
        const newEvent = new CustomEvent('HTMLEvents', {
          bubbles: true,
          detail: {
            target,
            value,
            checked: isChecked,
          },
        });

        const { changeVal } = this.props;
        changeVal(newEvent);
      }
    );
  }

  render() {
    const { className, children, checked, disabled, ...props } = this.props;
    const { isChecked } = this.state;

    const withChildren = !!children;
    const radio = (
      <StyledRadio
        {...props}
        checked={Boolean(isChecked)}
        className={withChildren ? '' : className}
        described={withChildren}
        onClick={disabled ? null : this.handleChange}
        ref={this.setRef}
      />
    );

    if (!withChildren) {
      return radio;
    }

    return (
      <StyledLabel className={className} disabled={disabled}>
        {radio}
        {children}
      </StyledLabel>
    );
  }
}

Radio.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

Radio.defaultProps = {
  checked: false,
  disabled: false,
  children: '',
  className: '',
  onChange: Function.prototype,
};

const StyledLabel = styled.label`
  cursor: pointer;
  align-items: center;
  background-color: transparent;
  color: #17181a;
  display: flex;
  font-size: 12px;
  line-height: 16px;

  ${props =>
    props.disabled &&
    `
    cursor: default;
  `}
`;

const StyledRadio = styled.input.attrs({
  type: 'radio',
})`
  ${props =>
    props.described &&
    `
    margin-right: 5px;
  `}
`;

export default Radio;
